import { Controller } from '@hotwired/stimulus';

export default class ChartingChatController extends Controller {
  static targets = ['panel', 'messages'];

  open() {
    if (this.panelTarget.dataset.open === 'true') return;

    this.panelTarget.dataset.open = 'true';
    this.element.dataset.open = 'true';
  }

  close() {
    this.panelTarget.dataset.open = 'false';
    this.element.dataset.open = 'false';
  }

  toggle() {
    if (this.panelTarget.dataset.open === 'true') {
      this.close();
    } else {
      this.open();
    }
  }

  messagesTargetConnected(el) {
    this.scrollMessagesToBottom('instant');

    this.messagesObserver = new MutationObserver(() => this.scrollMessagesToBottom());
    this.messagesObserver.observe(el, { childList: true, subtree: true, characterData: true });

    this.messagesResizeObserver = new ResizeObserver(() => this.scrollMessagesToBottom('instant'));
    this.messagesResizeObserver.observe(el);
  }

  messagesTargetDisconnected() {
    this.messagesObserver?.disconnect();
    this.messagesObserver = null;

    this.messagesResizeObserver?.disconnect();
    this.messagesResizeObserver = null;
  }

  scrollMessagesToBottom(behavior = 'smooth') {
    this.messagesTarget.scrollTo({ top: this.messagesTarget.scrollHeight, behavior });
  }
}
